@if (selected() || this.mode() === 'Create') {
  <app-dialog [ngClass]="mentionPeopleScreen ? 'mention-people-container' : ''">
    @if (shareWithFriendsDisplay()) {
      <h2 title>My Friends</h2>
    }

    @if (isPreview()) {
      <h2 title>Story preview</h2>
    } @else if (selectFacetsScreen()) {
      <h2 title>Select Facets</h2>
    } @else if (!shareWithFriendsDisplay()) {
      <h2 title>{{ mode() }} story</h2>
    }

    @if (selectFacetsScreen()) {
      @if (!currentSelectedFacets.length || chooseFacetUnitsPage() === null) {
        <app-multi-facet-selection
          class="mb-7"
          [facets]="availableFacets"
          [selectedFacetAliases]="selectedFacetAliases()"
          (selectedFacetChanged)="onSelectedFacetChanged($event)"
        ></app-multi-facet-selection>
      } @else {
        <div class="container">
          <div *ngIf="currentSelectedFacets.length && chooseFacetUnitsPage() !== null" class="mb-4">
            Please select {{ currentSelectedFacets[chooseFacetUnitsPage() || 0].name }} Facet
          </div>
          <app-facet-grid-compact-container
            class="mb-4"
            [units]="getUnitsForFacet(currentSelectedFacets[chooseFacetUnitsPage() || 0].id)"
            [selectedUnits]="selectedFacetUnits"
            (toggle)="toggleFacetModel($event)"
            [isCheckbox]="true"
          ></app-facet-grid-compact-container>
        </div>
      }

      <div class="buttons" footer>
        <div class="flex">
          <button appButton type="button" (click)="selectUnitsForFacet()" class="min-w-[200px]">Next</button>

          @if (selectFacetsScreen() && chooseFacetUnitsPage() === null && !addMoreFacetsScreen()) {
            <button appTextButton type="button" class="min-w-[200px] ml-4" color="blue" (click)="skipFacets()">
              Skip selection
            </button>
          }
        </div>

        @if (selectFacetsScreen() && chooseFacetUnitsPage() !== null) {
          <button appTextButton type="button" class="back-button" color="blue" (click)="backToPrevious()">Back</button>
        }
      </div>
    } @else if (editFacetScreen()) {
      <div class="container">
        <div *ngIf="selectedFacets().length && editFacet" class="mb-4">Please select {{ editFacet.name }} Facet</div>
        <app-facet-grid-compact-container
          [units]="allInCurrentFacet"
          [selectedUnits]="selectedInCurrentFacet"
          (toggle)="toggleFacetModel($event)"
          [isCheckbox]="true"
        ></app-facet-grid-compact-container>
      </div>

      <div class="buttons" footer>
        <div class="flex">
          <button appButton type="button" (click)="finishEditFacet()" class="min-w-[200px]">Save</button>
        </div>
      </div>
    } @else {
      <form [formGroup]="form()">
        <div formArrayName="facets">
          <div *ngFor="let alias of facets()?.controls; let i = index" class="last:mb-0 mb-20">
            <div [formGroupName]="i">
              @if (isSelectFacets()) {
                <app-inline-dialog-title>Select facets</app-inline-dialog-title>

                @for (facet of selectedFacets(); track $index) {
                  <div class="container">
                    <div class="mb-4">Please select {{ facet.name }} Facet</div>

                    <app-facet-grid-compact-container
                      [facets]="[facet]"
                      (toggle)="toggleFacetModel($event)"
                      [isCheckbox]="true"
                    ></app-facet-grid-compact-container>
                  </div>
                }
              } @else if (isPreview()) {
                <app-story-preview
                  (shareWithFriendsScreen)="showShareWithFriendsScreen($event)"
                  [isPreviewMode]="isPreview()"
                  [audioUrl]="formArray().at(0).value?.audio"
                  [story]="this.getSubmitPayload(formArray().at(0).value)"
                  [imageUrls]="previewUrls()"
                >
                </app-story-preview>
              } @else if (mentionPeopleScreen) {
                <app-mention-people-screen
                  (mentionFriends)="onMentionFriends($event)"
                  [currentMentions]="displayedMentions"
                ></app-mention-people-screen>
              } @else if (shareWithFriendsDisplay()) {
                <app-share-story [acl]="storyAcl()" (shareWith)="updateAcl($event)"></app-share-story>
              } @else {
                <app-form-grid>
                  <div>
                    <app-input>
                      <input type="text" formControlName="title" placeholder="Story title" />
                    </app-input>

                    <app-datepicker
                      [validate]="validateDatePicker()"
                      (dateChange)="onDateChange($event)"
                      [dateData]="dateData"
                      [userYears]="userYears()"
                    ></app-datepicker>

                    <app-voice-recording
                      class="mb-3 block"
                      formControlName="audio"
                      (stateChanged)="setAudioState($event)"
                      [audioUrl]="audioUrl()"
                      (recorded)="onAudioRecorded($event)"
                      (removeAudio)="onRemoveAudio($event)"
                      (transcriptChange)="onTranscriptChange($event)"
                    >
                    </app-voice-recording>

                    @if (formArray().at(0).get('audio')?.value && !isUploaded() && isNewAudioRecorded()) {
                      <div class="convert-button" (click)="convertVoiceToText()">Convert to text</div>
                    }

                    <div class="mb-4">
                      <div (click)="mentionPeople()" class="mention-people">
                        Mention people
                        <app-icon class="mr-1 icon" name="heroChevronRight"></app-icon>
                      </div>

                      @if (displayedMentions.size) {
                        <div class="mention-users truncate">
                          @for (entry of mentionUsersArr; track entry[0]; let last = $last) {
                            @if (entry && entry.length > 0) {
                              <span [title]="'@' + entry[1].userName">
                                {{ '@' + entry[1].userName }}
                              </span>
                              {{ !last ? ', ' : '' }}
                            }
                          }
                        </div>
                      }
                    </div>

                    <app-file-upload
                      class="h-[130px] file-upload-container"
                      formControlName="imageFile"
                      [dragDrop]="true"
                      [showPreview]="false"
                      mode="multiple"
                      (previewUrls)="setPreviewUrl($event)"
                    ></app-file-upload>
                  </div>
                  <div class="h-full flex">
                    <div class="textarea-container h-full w-full">
                      <textarea
                        [maxlength]="maxLengthTextarea"
                        class="textarea story-description"
                        formControlName="content"
                        placeholder="Your story..."
                        (input)="updateDescription($event)"
                      ></textarea>
                      <div class="char-counter">{{ textContent.length }}/{{ maxLengthTextarea }}</div>
                    </div>
                  </div>
                </app-form-grid>

                <app-file-upload-preview
                  class="mb-8 mt-4"
                  [previewUrls]="previewUrls()"
                  (remove)="onRemoveImage($event)"
                ></app-file-upload-preview>

                <p class="font-bold text-base mb-4 mt-6">What your story was about:</p>

                @if (selectedFacets().length) {
                  <app-facet-grid-compact-container
                    [facets]="selectedFacets()"
                    (toggle)="toggleFacetModel($event)"
                    [isDeleteIcon]="true"
                    [previewMode]="true"
                    [isChevronIcon]="true"
                    (edit)="editFacetModel($event)"
                    (delete)="deleteFacetModel($event)"
                  >
                  </app-facet-grid-compact-container>
                }

                <button
                  *ngIf="availableFacets.length"
                  appTextButton
                  type="button"
                  class="add-facets-buttons min-w-[200px] ml-4"
                  color="blue"
                  (click)="addMoreFacets()"
                >
                  Add facets +
                </button>
              }
            </div>
          </div>
        </div>
      </form>

      <div class="buttons" footer>
        @if (!shareWithFriendsDisplay() && !mentionPeopleScreen) {
          <div class="flex">
            <button
              appButton
              type="button"
              (click)="onSubmit()"
              class="min-w-[200px]"
              [disabled]="!selectedFacetType()"
            >
              {{ submitButtonText() }}
            </button>

            @if (!isSelectFacets() && !isPreview() && this.mode() === 'Create' && !mentionPeopleScreen) {
              <button
                appTextButton
                type="button"
                class="min-w-[200px] ml-4"
                color="blue"
                [disabled]="!selectedFacetType()"
                (click)="onSaveDraft()"
              >
                Save story to draft
              </button>
            }
          </div>
        }

        @if (mentionPeopleScreen) {
          <button appButton type="button" (click)="back()" class="min-w-[200px]">Next</button>
        }

        @if ((isSelectFacets() || isPreview()) && !shareWithFriendsDisplay()) {
          <button appTextButton type="button" class="back-button" color="blue" (click)="back()">Back</button>
        }

        @if (shareWithFriendsDisplay()) {
          <button appTextButton type="button" class="back-button share-screen" color="blue" (click)="backToPreview()">
            Back
          </button>
        }
      </div>
    }
  </app-dialog>
}
